import { createContext, useContext, useState } from 'react';
import api from '../utils/api';

const SchoolAuthContext = createContext(null);

export const SchoolAuthProvider = ({ children }) => {
  const [school, setSchool] = useState(() => {
    try { return JSON.parse(localStorage.getItem('school_data')); } catch { return null; }
  });

  const login = async (email, password) => {
    const res = await api.post('/schools/login', { email, password });
    setSchool(res.data.data);
    localStorage.setItem('school_data', JSON.stringify(res.data.data));
    localStorage.setItem('school_token', res.data.token);
    return res.data.data;
  };

  const logout = async () => {
    try { await api.post('/schools/logout'); } catch {}
    setSchool(null);
    localStorage.removeItem('school_data');
    localStorage.removeItem('school_token');
  };

  return (
    <SchoolAuthContext.Provider value={{ school, login, logout }}>
      {children}
    </SchoolAuthContext.Provider>
  );
};

export const useSchoolAuth = () => useContext(SchoolAuthContext);
